import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { isEqual } from "lodash";
import { h } from "preact";
import { BasicAgGrid, IHeader } from "../../common/components/AgGrid/index";
import { ApiBackedScComponent } from "../../common/components/ApiBackedScComponent";
import {
  MakeGenericApiCall,
  MakeSalesCreditRoleProfile,
} from "../../common/generic/generic-api";
import {
  CheckReponseDataForError,
  GenericFilterBuilder,
} from "../../common/generic/generic-helper";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericRequest } from "../../common/generic/generic-types";
import { ConvertFilter } from "../../common/salescredit/salescredit-filter-help";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import {
  BuildSalesCreditFilters,
  CreateDateFromFilter,
} from "../../common/salescredit/salescredit-search-criteria";
import { IProps } from "../../common/salescredit/salescredit-types";
import { getMapping } from "../utils/helper";

interface IState {
  data: any[];
  headers: IHeader[];
}
export class SalescreditByProductClass extends ApiBackedScComponent<
  IProps & IWidgetConfigurationProps,
  IState
> {
  public constructor() {
    super();
    this.setState({
      data: [],
      headers: [],
    });
  }

  protected shouldFetchApiData(nextProps: IProps): boolean {
    if (!isEqual(this.props.filters, nextProps.filters)) {
      return true;
    }
    return false;
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <div style="display:block;height:100%; overflow:hidden">
        <BasicAgGrid
          onChange={this.props.onChange}
          rowData={this.state.data}
          columnDefs={this.state.headers}
          suppressAggFuncInHeader={true}
          groupIncludeHeader={true}
          groupSuppressAutoColumn={true}
          groupDefaultExpanded={3}
          showExpand={true}
          fileName={"SC by product"}
          userSelection={this.props.userSelection}
        />
      </div>
    );
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    this.setDataStatus("loading");
    const userRole = await MakeSalesCreditRoleProfile(
      props.headers,
      this.props.widgetConfiguration,
      undefined,
      this.state.correlationId
    );

    if (userRole.Role === undefined) {
      this.setDataStatus("no-access-rights");
      this.setStatusText(userRole.StatusText);
      return;
    }

    const filtersConverted = ConvertFilter(props.filters);
    const filters = BuildSalesCreditFilters(filtersConverted);
    const profileDictionary = new SCProfileDictionary();

    const attributes =
      SCAttributes.SC_PRODUCT_LEVEL1 +
      "," +
      SCAttributes.SC_PRODUCT_LEVEL2 +
      "," +
      SCAttributes.SC_PRODUCT_LEVEL3 +
      "," +
      SCAttributes.SC_PRODUCT_LEVEL4;
    const kpis = profileDictionary
      .GetGridFields(userRole.Profile)
      .map(x => x.Kpi);

    const genericRequest: IGenericRequest = {
      aggregationAttributes: attributes,
      date: CreateDateFromFilter(filtersConverted),
      filter: GenericFilterBuilder(filters),
      kpis: kpis.join(","),
      sort: "-" + profileDictionary.GetKpi(userRole.Profile, SCKpis.SC_YTD),
    };

    const responseData = await MakeGenericApiCall(
      props.headers,
      "sc",
      genericRequest,
      this.props.widgetConfiguration,
      this.state.correlationId
    );
    const errorStatus = CheckReponseDataForError(responseData);
    if (errorStatus) {
      this.setDataStatus(errorStatus);
      this.setStatusText(responseData.statusText);
      this.setState({
        data: [],
        headers: [],
      });
      return;
    }
    const mappedDetails = getMapping(responseData, userRole);
    if (mappedDetails !== undefined) {
      this.setState({
        data: mappedDetails.Rows,
        headers: mappedDetails.Headers,
      });
      this.setDataStatus("ready");
    } else {
      this.setState({
        data: [],
        headers: [],
      });
      this.setDataStatus("no-data");
    }
  }
}

export const SalescreditByProduct = withWidgetConfiguration(
  SalescreditByProductClass
);
